module.exports = __webpack_public_path__ + "img/home-lazy.6b6458bc.png";